import axios from 'axios';
import { LEADS_ENDPOINT } from 'cfgCommon/endpoints'

export async function closeLead(leadId,body) {

    try {
      return await axios.put(`${LEADS_ENDPOINT}/${leadId}`, body)
    } catch {    
      throw new Error()
    }
  
  }